@if (blob || audioUrl) {
	<audio #audioPlayer [src]="blob ? blob : audioUrl" [controls]="true"></audio>
}
